import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Suspense, lazy } from "react";
import { ModalLoad } from "./components/Modals/Modals";
import Auth from "./components/Auth/Auth";
import Layout from "./components/Layout/Layout";
import Loading from "./pages/Loading/Loading";
import LanguageRedirect from "./components/LanguageRedirect/LanguageRedirect";

const WorkstationsList = lazy(() =>
  import("./pages/WorkstationsList/WorkstationsList")
);

const NotFound = lazy(() => import("./pages/NotFound/NotFound"));
const Dashboard = lazy(() => import("./pages/Dashboard/Dashboard"));
const SelectParts = lazy(() => import("./pages/SelectParts/SelectParts"));
const SelectPartsTracking = lazy(() =>
  import("./pages/SelectPartsTracking/SelectPartsTracking")
);
const PrintTags = lazy(() => import("./pages/PrintTags/PrintTags"));
const PrintTagsTracking = lazy(() =>
  import("./pages/PrintTagsTracking/PrintTagsTracking")
);
const ReprintTagsTracking = lazy(() =>
  import("./pages/ReprintTagsTracking/ReprintTagsTracking")
);
const HelpBoard = lazy(() => import("./pages/HelpBoard/HelpBoard"));
const Checklists = lazy(() => import("./pages/Checklists/Checklists"));
const ChecklistsManual = lazy(() =>
  import("./pages/ChecklistsManual/ChecklistsManual")
);

const Checklist = lazy(() => import("./pages/Checklist/Checklist"));
const DashboardTracking = lazy(() =>
  import("./pages/DashboardTracking/DashboardTracking")
);
const DashboardMO = lazy(() => import("./pages/DashboardMO/DashboardMO"));
const ManufacturingOrder = lazy(() =>
  import("./pages/ManufaturingOrder/ManufacturingOrder")
);

const MenuPrintTags = lazy(() => import("./pages/MenuPrintTags/MenuPrintTags"));

const CreateTags = lazy(() =>
  import("./pages/PrintTagsTracking/CreateTags/CreateTags")
);

const ReprintTagsManufacturingOrders = lazy(() =>
  import(
    "./pages/ReprintTagsManufacturingOrders/ReprintTagsManufacturingOrders"
  )
);

const App = () => {
  return (
    <Suspense fallback={<Loading />}>
      <BrowserRouter>
        <Layout>
          <LanguageRedirect />
          <Routes>
            <Route
              index
              path="/:lang/workstations/:tab?"
              element={<WorkstationsList />}
            />
            <Route
              path="/:lang/select-parts/:quantity?/:part?"
              element={<SelectParts />}
            />
            <Route
              path="/:lang/select-parts-tracking"
              element={<SelectPartsTracking />}
            />
            <Route path="/:lang/dashboard" element={<Dashboard />} />
            <Route
              path="/:lang/dashboard-tracking/:typeView?"
              element={<DashboardTracking />}
            />
            <Route
              path="/:lang/mo/:option?/:id?"
              element={<ManufacturingOrder />}
            />
            <Route
              path="/:lang/dashboard-mo/:typeView?"
              element={<DashboardMO />}
            />

            <Route path="/:lang/print-tags" element={<PrintTags />} />
            <Route
              path="/:lang/print-tags-tracking"
              element={<PrintTagsTracking />}
            />
            <Route
              path="/:lang/reprint-tags-tracking"
              element={<ReprintTagsTracking />}
            />
            <Route
              path="/:lang/reprint-tags-manufacturing-orders/:lot?/:standardpack?"
              element={<ReprintTagsManufacturingOrders />}
            />

            <Route path="/:lang/menu-print-tags" element={<MenuPrintTags />} />
            <Route path="/:lang/checklists" element={<Checklists />} />
            <Route
              path="/:lang/checklist/:name/:id/:historyId"
              element={<Checklist />}
            />
            <Route
              path="/:lang/checklists-manual"
              element={<ChecklistsManual />}
            />
            <Route
              path="/:lang/help-board/:type?/:part?"
              element={<HelpBoard />}
            />
            <Route path="/:lang/tags/:view?" element={<CreateTags />} />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </Suspense>
  );
};

const AppWithAuthControl = Auth(App);
// const AppWithAuthControl = App;

export default AppWithAuthControl;
